import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import PSStations from './slides/PSStations';
import { withWidth } from '@material-ui/core';
import JoinTheWaitlistButton from '../../../../components/buttons/JoinTheWaitlist';
import { Button } from '@mui/material';
const useStyles = makeStyles({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
  root: {
    position: 'relative',
    width: '100%',
    // height: '100vh',
    overflow: 'hidden',
    padding: 0,
  },
  slide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#fff',
    fontSize: '30px',
  },
  slide1: {
    backgroundColor: '',
  },
  slide2: {
    backgroundColor: '',
  },
  slide3: {
    backgroundColor: '',
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
  },
  navButtonLeft: {
    left: 0,
  },
  navButtonRight: {
    right: 0,
  },
});

const WelcomeSlide = ({ width, ...props }) => {
  const classes = useStyles();

  // use for slides height elements:
  const [height, setheight] = useState(0);

  const [index, setIndex] = useState(0);

  return (
    <Box className={classes.root} sx={{ padding: 0 }}>
      <Typography
        className={classes.textMonarcha}
        variant="h5"
        sx={{
          // fontSize:
          //   width === 'xl'
          //     ? '1.85rem !important'
          //     : width === 'xs'
          //     ? '1rem !important'
          //     : '1.8rem !important',
          fontSize: width === 'xl' ? '1.75rem !important' : '1.75rem !important',

          textAlign: 'center',
          lineHeight: 1.3,
          marginBottom: { xs: 1, sm: 0 },
          color: '#ffbf12',
        }}
      >
        Personal Brand{width === 'xs' && <br />} startup Journey on {width === 'xs' && <br />}PassionStocks
      </Typography>
      <Typography
        className={classes.textOpenSans}
        variant={ 'subtitle1'}
        sx={{
          textAlign: 'center',
          lineHeight: 1.3,
          color: '#ffffff77',
          marginBottom: 3,
          display:'block'
        }}
      >
        PassionStocks lets content creators{width === 'xs' && <br />} launch their personal brand{" "}{width === 'xs' && <br />}
        as a startup company.
      </Typography>
      <PSStations
        isPhone={props.isPhone}
        className={`${classes.slide}`}
        setIndex={setIndex}
        setheight={setheight}
      />{' '}
      <Box sx={{ marginTop: [18, 0, 5, 0][index] }}>
        {/* <JoinTheWaitlistButton /> */}
        <Button
            className={classes.textOpenSans}
            sx={{
              textTransform: "none",
              color: "black",
              fontSize: "16px",
              lineHeight: 2.1,
              padding: "5px 65px",
              background: "#ffbf12",
              borderRadius: "50px",
              margin: "20px auto",
              display: "block",
              "&:hover": { background: "#ffbf12" },
            }}
            onClick={() => {
              window.open("https://passionstocks.com");
            }}
          >
            Sign Up / Log In
          </Button>
      </Box>
    </Box>
  );
};

export default withWidth()(WelcomeSlide);
